import React from 'react';
import "./style.sass";

export function BarraStepper({ itemActivo }) {
    return (
        <>
            <ul className="md-stepper-horizontal orange">
                <li className={itemActivo === 1 ? "md-step active activeUno done" : itemActivo === 2 || itemActivo === 3 || itemActivo === 4 ? "md-step active done" : "md-step done"}>
                    <div className="md-step-circle"><span>Información personal</span></div>
                    <div className="md-step-title">Información personal</div>
                    <div className="md-step-bar-left"></div>
                    <div className="md-step-bar-right"></div>
                    {/* <div className={itemActivo === 12 ? "md-step-bar-right rightMedioRed" : "md-step-bar-right"}></div> */}
                </li>
                <li className={itemActivo === 2 ? "md-step active activeUno done" : itemActivo === 3 || itemActivo === 4 ? "md-step active done" : "md-step done"}>
                    <div className="md-step-circle"><span>Información de empleo</span></div>
                    <div className="md-step-title">Información de empleo</div>
                    {/* <div className={itemActivo === 12 ? " md-step-bar-left leftMedioGris" : "md-step-bar-left"}></div> */}
                    <div className="md-step-bar-left"></div>
                    <div className="md-step-bar-right"></div>
                </li>
                <li className={itemActivo === 3 ? "md-step active activeUno done" : itemActivo === 4 ? "md-step active done" : "md-step done"}>
                    <div className="md-step-circle"><span>Información financiera</span></div>
                    <div className="md-step-title">Información financiera</div>
                    <div className="md-step-bar-left"></div>
                    <div className="md-step-bar-right"></div>
                </li>
                <li className={itemActivo === 4 ? "md-step active done ultimo" : "md-step done ultimo"}>
                    <div className="md-step-circle"><span>Solicitud finalizada</span></div>
                    <div className="md-step-title">Solicitud finalizada</div>
                    {/* <div className="md-step-bar-left"></div> */}
                    {/* <div className="md-step-bar-right"></div> */}
                </li>
            </ul>
        </>
    )
}